import Model from 'src/models/model'
import { useIsCategoryAvailable } from 'src/modules/checkout/composables/sales-availability/categories/IsCategoryAvailable'
import { useIsItemAvailable } from 'src/modules/checkout/composables/sales-availability/items/IsItemAvailable'
import { inject, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate category availability.
const DEFAULT_OPTIONS = Object.freeze({
  categories: [],
  items: [],
  salesChannel: null,
  order: null,
  registerType: null,
  showing: null
})

export function useHasPurchasableFood () {
  const currentSite = Model.configuration?.currentSite

  const isConsumerAppMode = toValue(inject('isConsumerAppMode'))
  const isKioskAppMode = toValue(inject('isKioskAppMode'))

  const { isCategoryAvailable } = useIsCategoryAvailable()
  const { isItemAvailable } = useIsItemAvailable()

  function hasPurchasableFood ({ categories, items, salesChannel, order, registerType, showing } = DEFAULT_OPTIONS) {
    const categoriesValue = toValue(categories)
    const itemsValue = toValue(items)
    const salesChannelValue = toValue(salesChannel)
    const orderValue = toValue(order)
    const registerTypeValue = toValue(registerType)
    const showingValue = toValue(showing)

    if (!isConsumerAppMode && !isKioskAppMode) return false

    if (isKioskAppMode && !registerTypeValue?.allowKioskFoodAndBeverageOrdering) return false

    if (!currentSite.allowItemOrdersOnline) return false

    if (!_.isNil(showingValue)) {
      if (!showingValue?.allowItemOrdersOnline) return false
      if (showingValue?.movie?.disableOnlineConcessions) return false
      if (!currentSite.allowItemSalesWithTicketPurchases) return false
    }

    const hasAvailableCategories = _.some(categoriesValue, category => isCategoryAvailable(category, { salesChannel: salesChannelValue, order: orderValue }).isAvailable)
    const hasAvailableFeaturedItems = hasAvailableCategories || _.some(itemsValue, item => item.isFeature && isItemAvailable(item, { salesChannel: salesChannelValue, order: orderValue }).isAvailable)

    return hasAvailableCategories || hasAvailableFeaturedItems
  }

  return {
    hasPurchasableFood
  }
}
